import React, { Component } from 'react'
import WidgetComponents from './widgets/WidgetComponents'
import ActionsBtn from './partials/ActionsBtn'


export default class CardRenderer extends Component {
    state = {

        currentMedia: 'lg',
        ads: [
            { src: '/images/video/vid8.jpg' }
        ],

        fullUrl: [
            { href: '#' }
        ],
        headers: [],
        tempData: {}

    }


    // componentDidMount() {
    //     // console.log('props====', this.props)
    //     this.init()
    // }


    // componentDidUpdate(prevProps) {

    //     // console.log(this.props.view?.settings)
    //     if (this.props.view?.settings?.cardInfo != this.state.cardInfo) {
    //         this.init()
    //     }
    // }



    // init() {

    //     this.setState({ cardInfo: this.props.view?.settings?.cardInfo })
    //     // let mainHeaders = this.props.headers ? [...this.props.headers] : []
    //     // let headers = []
    //     // // let headersKey = Object.keys(this.props.headersData)
    //     // // headers = headers.filter(header => headersKey.includes(header.key))
    //     // mainHeaders.forEach(header => {
    //     //     let valid = getObject(this.props.headersData, header.key) ?? getObject(this.props.headersData, ('**files.' + header.key), 1) ?? false
    //     //     if (valid) {
    //     //         // header.information.disabled = true
    //     //         headers.push(header)
    //     //     }
    //     // })
    //     // this.setState({ headers, show: false }, () => {
    //     //     this.setState({ show: true })
    //     // })


    //     let cardElements = []
    //     let content = this.props.view?.settings?.cardInfo

    //     // if (cardInfo && Array.isArray(cardInfo)) {
    //     //     cardInfo.forEach((element, index) => {
    //     //         cardElements.push(element)
    //     //     });
    //     // }

    //     // console.log(cardElements)

    //     this.setState({ content })
    // }


    // textVariableReplacer = (data, content) => {

    //     if (content) {

    //         let output = content

    //         // console.log("HERE")
    //         // for (const [key, value] of Object.entries(filter)) {
    //         let reg = new RegExp('\{\{(.*?)\}\}', 'g')

    //         let matches = content.match(reg)

    //         // matches.forEach((match,i) => {

    //         for (let index = 0; index < matches.length; index++) {
    //             const match = matches[index];


    //             let key = match.replace(/{/g, '').replace(/}/g, '')

    //             for (let j = 0; j < this.props.headers.length; j++) {
    //                 const header = this.props.headers[j];


    //                 // this.props.headers?.forEach(header => {
    //                 // let value
    //                 if (key == header.information?.label || key == header.key) {


    //                     // if (key == header.information?.label) {
    //                     //     value = header.information?.label
    //                     // }

    //                     // if (value == null && key == header.key) {
    //                     let value = getObject(data, header.key)
    //                     // }

    //                     switch (header.type) {
    //                         case "PriceInput":
    //                             value = priceStandardView(value)
    //                             break;

    //                         case "NumberInput":
    //                             value = priceStandardView(value)
    //                             break;

    //                         case "DateInput":
    //                             let format = 'DD MMM YYYY'
    //                             if (header.information?.showHour) {
    //                                 format = format + ' hh:mm'
    //                             }
    //                             if (moment(Number(this.props.data)).isValid()) {

    //                             }
    //                             value = moment(Number(value)).format(format)
    //                             break;

    //                         default:
    //                             break;
    //                     }


    //                     let nreg = new RegExp(match, 'g')

    //                     output = output.replace(nreg, value)

    //                     // console.log(output)
    //                     // return output
    //                 }


    //             }
    //         }

    //         return output

    //     }

    // }

    // componentDidMount() {
    //     let fullUrl = siteConfig.rootDomain + Router.router.asPath

    //     // console.log(fullUrl)
    //     this.setState({ fullUrl })
    // }


    // actionClicked = (prop, data, index) => {

    //     // console.log(prop, data, index)

    //     let stageList = ['sendTo']
    //     if (stageList.includes(prop.key)) {
    //         let cIndex = stageList.indexOf(prop.key)
    //         this.stageManager.changeStage(stageList[cIndex])
    //     }
    //     else {
    //         this.functionsHandler(prop, data, index)
    //     }

    // }

    actionClicked = (prop, extra) => {
        // console.log(prop, extra)
        this.props.actionClicked(prop, this.props.data, this.props.index, extra)
        if (this.actionsButton) {
            this.actionsButton.hide()
        }
    }



    // functionsHandler = (prop, data, index) => {
    //     if (typeof prop.function == 'function') {
    //         // console.log('herefunc5')
    //         prop.function(data, this.selectedRowIndex)
    //     } else {
    //         console.log(prop.function)
    //         if (this.props[prop.function]) {
    //             // console.log('herefunc')
    //             this.props[prop.function](data, index, prop)
    //         } else {
    //             // console.log('herefunc2', prop, index)
    //             this.props.functionsHandler('collection', prop.function, data, index, prop)
    //         }
    //     }
    // }


    componentSelected = () => {

    }


    renderDiv = (section, parents, index, rowChildrenCount, columnChildrenCount, fullData) => {

        // console.log(section.type)


        if (Array.isArray(section?.children)) {

            let rowDropables = [
                { key: 'top', left: 0, width: '100%', top: 0, height: 10, backgroundColor: '#007aff10' },
                { key: 'bottom', left: 0, width: '100%', bottom: 0, height: 10, backgroundColor: '#007aff10' },
                // { key: 'left', left: 0, width: 10, top: 0, height: '100%', backgroundColor: '#ee505010' },
                // { key: 'left', right: 0, width: 10, top: 0, height: '100%', backgroundColor: '#ee505010' },

            ]

            let columnDropables = [
                // { key: 'top', left: 0, width: '100%', top: 0, height: 10, backgroundColor: '#007aff10' },
                // { key: 'bottom', left: 0, width: '100%', bottom: 0, height: 10, backgroundColor: '#007aff10' },
                { key: 'left', left: 0, width: 5, top: 0, height: '100%', backgroundColor: '#7a00ff10' },
                { key: 'right', right: 0, width: 5, top: 0, height: '100%', backgroundColor: '#7a00ff10' },

            ]

            let style = section.style ?? {}
            let mediaWidth = (style.width && typeof style.width == 'object') ? `${style.width[this.state.currentMedia]}%` : style.width ?? '100%'
            let activeForResize = false

            return (
                <div ref={el => this[section.id] = el} key={section.id} className={'position-relative d-flex ' + (section.id)} style={{ width: mediaWidth, maxWidth: style.maxWidth ? (style.maxWidth + (style.maxWidthUnit ?? '%')) : null, padding: style.padding ?? null, background: style.background, boxShadow: style.boxShadow, padding: style.margin, margin: 0, borderRadius: style.borderRadius, border: (this.state.isDragging || activeForResize) ? "0px dashed #ddd" : '0px solid transparent', boxSizing: 'border-box', minHeight: this.props.editMode ? 15 : 0, }} >
                    <div ref={el => this["container-" + section.id] = el} className={'flex-1 ' + (section.type == 'row' ? ' section-row d-flex flex-wrap  ' : ' section-column d-flex flex-column')} style={{ boxShadow: (activeForResize && this.props.editMode) ? 'inset 0px 0px 0px 1px #e0e0e0' : null, outlineOffset: 0, outline: (this.props.editMode && style.margin && activeForResize) ? `${style.margin} solid #f0f0f0` : null }}>

                        {section?.children.map((element, eIndex) => {

                            let newParents = [...parents]
                            newParents.push({ id: section.id, type: section.type, style: section.style })
                            // console.log(newParents)
                            return (
                                this.renderDiv(element, [...newParents], eIndex, (section.type == 'row' ? section?.children?.length : rowChildrenCount), (section.type == 'column' ? section?.children?.length : columnChildrenCount), fullData)
                            )
                        })}


                        {this.state.isDraging && section.type == 'row' && !section.temp && rowDropables.map((dropable, dIndex) => {
                            return (
                                <div key={dIndex} className={'dragable '} onDragOver={(e) => e.preventDefault()} onMouseOver={(e) => this.onMouseOver(e, [...parents], { id: section.id, type: 'row', parents, position: dropable.key }, dropable.key)} onDragEnter={(e) => this.onDragEnter(e, [...parents], { id: section.id, type: 'row', parents, position: dropable.key }, dropable.key)} onDragLeave={(e) => this.onDragLeave(e)} style={{ zIndex: 1, position: 'absolute', top: dropable.top, left: dropable.left, bottom: dropable.bottom, right: dropable.right, height: dropable.height, width: dropable.width, backgroundColor: dropable.backgroundColor }}>

                                </div>
                            )
                        })}



                        {this.state.isDraging && section.type == 'column' && !section.temp && columnDropables.map((dropable, dIndex) => {
                            return (
                                <div key={dIndex} className={'dragable '} onDragOver={(e) => e.preventDefault()} onMouseOver={(e) => this.onMouseOver(e, [...parents], { id: section.id, type: 'column', parents, position: dropable.key }, dropable.key)} onDragEnter={(e) => this.onDragEnter(e, [...parents], { id: section.id, type: 'column', parents, position: dropable.key }, dropable.key)} onDragLeave={(e) => this.onDragLeave(e)} style={{ zIndex: 1, position: 'absolute', top: dropable.top, left: dropable.left, bottom: dropable.bottom, right: dropable.right, height: dropable.height, width: dropable.width, backgroundColor: dropable.backgroundColor }}>

                                </div>
                            )
                        })}


                    </div>
                </div>
            )

        } else {
            if (section.type == 'dropZone') {
                return (
                    <div key={section.id} className='p-1' style={{ flex: 12, pointerEvents: 'none' }} >
                        <div className='dropZone' style={{ borderRadius: 4, minHeight: 30, backgroundColor: '#007aff10', border: '1px solid #007aff' }}>
                            {/* <p>Ghost</p> */}
                        </div>
                    </div>
                )
            } else {

                let dropables = []

                let colStyle = Array.isArray(section.parents) ? (section.parents[section.parents?.length - 1]?.style ?? {}) : {}

                if (rowChildrenCount > 1) {
                    dropables.push({ key: 'bottom', left: 0, width: '100%', bottom: 0, height: 20, backgroundColor: '#ee505010' },)
                    dropables.push({ key: 'top', left: 0, width: '100%', top: 0, height: 20, backgroundColor: '#ee505010' })
                }

                if (columnChildrenCount > 1) {
                    dropables.push({ key: 'left', left: 0, width: 20, top: 0, height: '100%', zIndex: 1, backgroundColor: '#ee505010' },)
                    dropables.push({ key: 'right', right: 0, width: 20, top: 0, height: '100%', zIndex: 1, backgroundColor: '#ee505010' },)
                }




                // let Component = this.props.componentsInfo[section.type]?.components
                // console.log('ssvthis.props.params',section.type)
                let Component = WidgetComponents[section.type] ?? null
                let data = section?.information
                let header = section ?? { key: section.id, id: section.id, information: {} }
                // console.log(Component)
                if (!header.information) {
                    header.information = {}
                }
                section.parents = parents

                let style = section.style ?? {}
                let mediaWidth = (style.width && typeof style.width == 'object') ? `${style.width[this.state.currentMedia]}%` : style.width ?? '100%'
                let mediaMargin = style.margin ? `${style.margin[this.state.currentMedia]}` : null


                // console.log(Component)
                // console.log(section.type)

                // console.log(this.props.componentsInfo)

                return (
                    <div key={section.id}

                        // className={'element position-relative d-flex ' + "mb-1 p-1  col-lg-" + (data.col ?? "4 ") + (" col-md-" + (data.col <= 6 ? '6 ' : data.col)) + (" col-" + (data.col <= 3 ? '6 ' : '12 '))} style={{ flex: 12, minHeight: 40 }} >
                        // className={'element position-relative h-100 d-flex ' + "mb-1 p-1  col-lg-" + (data.col ?? "12 ") + (" col-md-" + (data.col <= 6 ? '6 ' : data.col)) + (" col-" + (data.col <= 3 ? '6 ' : '12 '))} style={{ flex: 12, minHeight: 40 }} >
                        className={'element  position-relative  d-flex ' + " mb-0 p-0  "} style={{ margin: mediaMargin, width: mediaWidth, minHeight: this.props.editMode ? 15 : 0 }} >

                        {/* {!this.props.userView && this.state.selectedSection?.id == section.id && (
                            <div className='h-100 w-100 px-2 d-flex pb-2' style={{ position: 'absolute', top: 0, left: 0, zIndex: 3, alignItems: 'flex-end', justifyContent: 'flex-end', pointerEvents: 'none' }}>
                                <div className='builder-options-container flexc '>
                                    <img draggable={false} onMouseDown={(e) => { e.stopPropagation(); this.startMove(e, section) }} src='/assets/icons/drag-and-drop.svg' height={14} className="builder-options-icon invert  mrd-2" />
                                    <img onClick={(e) => { e.stopPropagation(); this.showConfig() }} src='/assets/icons/useful/settings.png' height={14} className="builder-options-icon invert  mrd-2" />
                                    <img onClick={(e) => { e.stopPropagation(); this.duplicateElement(section, parents, rowChildrenCount, columnChildrenCount) }} src='/assets/icons/useful/duplicate.svg' height={14} className="builder-options-icon invert  mrd-2" />
                                    <img onClick={(e) => { e.stopPropagation(); this.doRemoveElement(e, section, parents,) }} src='/assets/icons/useful/trash-o.svg' height={14} className="builder-options-icon invert  " />

                                    <div className='mx-2' style={{ height: 16, width: 1, backgroundColor: '#00000050' }}>
                                    </div>
                                    <img src='/assets/icons/useful/row.png' height={14} className="builder-options-icon invert  mrd-2" />
                                    <img src='/assets/icons/useful/column.png' height={14} className="builder-options-icon invert  mrd-2" />

                                </div>
                            </div>
                        )} */}
                        {/* <p>Text</p> */}
                        {/* {console.log('ssssssen:',section)} */}

                        {/* <p>{section.type}</p> */}
                        {/* {console.log(fullData)} */}
                        {Component && (
                            <div className={' w-100 flex-1 d-flex ' + (this.props.editMode ? 'builder-component-container-view' : '')} onClick={(e) => this.componentSelected(e, section)} style={{ border: this.state.selectedSection?.id == section.id ? '1px solid #007aff' : null, }}>
                                {/* {console.log('component::', this.props.componentsInfo, section)} */}

                                <div className='flex-1 w-100 d-flex flex-column' style={{ alignItems: colStyle?.align, }}>
                                    {/* pointerEvents: this.state.selectedSection?.id == section.id ? 'all' : 'none' */}

                                    {/* <Component changeValue={this.changeSection} data={this.state.currentSection} ref={el => this["component-" + header.key] = el} header={header} setStatus={this.setStatus} variables={this.props.variables} /> */}
                                    {/* <p className="text-center text-bold mt-2 mb-2 text-small">{data.title}</p> */}
                                    <Component section={section} changeValue={(key, value, extra) => this.changeSectionValue(key, value, extra, section)} data={data} ref={el => this["component-" + header.key] = el} header={header} setStatus={this.setStatus} variables={this.props.variables} width={this.props.width} params={this.props.params} changeWindowLink={this.props.changeWindowLink} baseUrl={this.props.baseUrl ? [...this.props.baseUrl] : null} windowData={this.props.windowData} colors={this.props.colors} changePage={this.props.changePage} pageChangePage={this.props.pageChangePage} applet={this.props.applet} userView={this.props.userView} fullData={fullData} headers={this.props.headers} onClick={this.actionClicked} actionClicked={this.actionClicked}/>
                                </div>
                            </div>
                        )}

                        {/* {this.state.isDraging && dropables.map((dropable, dIndex) => {
                            return (
                                <div key={dIndex} className='dragable' onDragOver={(e) => e.preventDefault()} onMouseOver={(e) => this.onMouseOver(e, [...parents], { id: section.id, type: section.type, information: section.information, parents, position: dropable.key }, dropable.key)} onDragEnter={(e) => this.onDragEnter(e, [...parents], { id: section.id, type: section.type, information: section.information, parents, position: dropable.key }, dropable.key)} onDragLeave={(e) => this.onDragLeave(e)} style={{ position: 'absolute', zIndex: dropable.zIndex, top: dropable.top, left: dropable.left, bottom: dropable.bottom, right: dropable.right, height: dropable.height, width: dropable.width, backgroundColor: dropable.backgroundColor }}>

                                </div>
                            )
                        })} */}
                    </div>
                )
            }
        }
    }



    render() {

        return (

            <div className=' w-100 '>
                {/* {console.log('this.props.content',this.props.content)} */}
                {Array.isArray(this.props.content) && this.props.content?.map((div, rIndex) => {
                    return (
                        this.renderDiv(div, [], null, null, null, this.props.data)
                    )
                })}

                {this.props.actions && (
                    <div className='pt-1 flexcc' style={{ zIndex: 1, position: 'sticky', bottom: 0 }}>
                        <ActionsBtn permissions={this.props.permissions} page={this.props.page} applet={this.props.applet} data={this.props.data} index={this.props.index} actions={this.props.actions} actionClicked={this.actionClicked} language={this.props.language} currentRecord={this.props.currentRecord} currentRecordStage={this.props.currentRecordStage} changeRecordStage={this.props.changeRecordStage} setCurrentRecordStage={this.props.setCurrentRecordStage} colors={this.props.colors} functionsHandler={this.props.functionsHandler} />
                    </div>
                )}
            </div>

        )
    }
}
